import { render, staticRenderFns } from "./Mbs2HelpModal.vue?vue&type=template&id=1a4c656a&"
import script from "./Mbs2HelpModal.vue?vue&type=script&lang=js&"
export * from "./Mbs2HelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports